import guest from './guest/messages';
import tenant from './tenant/messages';
import account from './account/messages';
import error from './error/messages';
import common from './common/messages';
import tasks from './tasks/messages';

let messages = Object.assign({}, guest, tenant, account, error, common, tasks);

export default messages;
